export default {
  quiz: {
    en: 'Get started with a quiz',
  },
}
